export default {
  root: {
    padding: '0 36px',
    marginTop: '8px',
    width: '100%',
  },
};
